var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLago(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.789,
    height: 54,
    viewBox: "0 0 37.789 54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Lago",
    transform: "translate(-261.911 -99.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_71422",
    "data-name": "Path 71422",
    d: "M268.962,99.526a7.051,7.051,0,0,0-7.051,7.051v18.745a14.1,14.1,0,0,0,14.1,14.1h0V106.577A7.051,7.051,0,0,0,268.962,99.526Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71423",
    "data-name": "Path 71423",
    d: "M329.47,243.6H312.834a14.071,14.071,0,0,0,14.071,14.071h1.916c.214.02.43.031.649.031a7.051,7.051,0,1,0,0-14.1Z",
    transform: "translate(-36.821 -104.178)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLago);
export default __webpack_public_path__ + "static/media/lago.e2429ede1dd5cfe4708cd3ce28f07041.svg";
export { ForwardRef as ReactComponent };